(function () {
  // Guard against the script being included once per section instance
  if (window.MediaWithText) return;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function MediaWithText(root) {
    this.root = root;
    this.container = root.querySelector('.js-media-with-text-video');

    if (!this.container) return;

    this.video = this.container.querySelector('.js-media-with-text-video-element');
    this.poster = this.container.querySelector('.js-media-with-text-poster');
    this.playButton = this.container.querySelector('.js-media-with-text-play');
    this.toggle = this.container.querySelector('.js-media-with-text-toggle');

    if (this.playButton) this.bindPlayButton();
    if (this.toggle && this.video) this.bindAutoplay();
  }

  // Poster with play button: hide the poster and start the video with sound and controls
  MediaWithText.prototype.bindPlayButton = function () {
    var self = this;

    this.playButton.addEventListener('click', function () {
      self.poster.hidden = true;

      if (self.video) {
        self.video.controls = true;
        self.video.muted = false;
        var playing = self.video.play();
        // Native controls are shown, so the user can still start it if the browser blocks play
        if (playing && playing.catch) playing.catch(function () {});
        self.video.focus();
        return;
      }

      var iframe = document.createElement('iframe');
      iframe.className = 'media-with-text__iframe';
      iframe.src = self.container.getAttribute('data-embed-url');
      iframe.title = self.container.getAttribute('data-video-label');
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      self.container.insertBefore(iframe, self.poster);
      iframe.focus();
    });
  };

  // Autoplay muted: only plays while in view, and not for users who prefer reduced motion
  MediaWithText.prototype.bindAutoplay = function () {
    var self = this;

    this.userPaused = reducedMotion;
    this.setToggleState(true);

    this.toggle.addEventListener('click', function () {
      if (self.video.paused) {
        self.userPaused = false;
        self.video.play();
      } else {
        self.userPaused = true;
        self.video.pause();
      }
    });

    this.video.addEventListener('play', function () {
      self.setToggleState(false);
    });

    this.video.addEventListener('pause', function () {
      self.setToggleState(true);
    });

    if (!('IntersectionObserver' in window)) {
      if (!this.userPaused) this.video.play();
      return;
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !self.userPaused) {
          var playing = self.video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else if (!entry.isIntersecting && !self.video.paused) {
          self.video.pause();
        }
      });
    }, { threshold: 0.25 }).observe(this.video);
  };

  MediaWithText.prototype.setToggleState = function (paused) {
    this.toggle.classList.toggle('is-paused', paused);
    this.toggle.setAttribute(
      'aria-label',
      this.toggle.getAttribute(paused ? 'data-label-play' : 'data-label-pause')
    );
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.js-media-with-text');

    Array.prototype.forEach.call(roots, function (root) {
      if (root.mediaWithText) return;
      root.mediaWithText = new MediaWithText(root);
    });
  }

  window.MediaWithText = MediaWithText;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
